import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'edit-app-dialog',
    templateUrl: './edit-app-dialog.component.html',
    styleUrls: ['./edit-app-dialog.component.scss'],
    providers: [],
    standalone: false
})
export class EditAppDialogComponent {

  error: string;

  constructor(public dialogRef: MatDialogRef<EditAppDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  save() {
    this.error = this.validate(this.data?.type);
    this.validate(this.data?.type);
    if (this.error) {
      return;
    }
    this.dialogRef.close(this.data.item);
  }

  cancel() {
    this.dialogRef.close();
  }

  validate(type) {
    switch (type) {
      case 'installedWidgetIds':
        return !this.data?.item?.default && !this.data?.item?.translations?.find(t => t.language === 'de')?.widgetStyle?.length ? 'packages.navigation.errors.noWidgetStyle' : null;
      case 'installedTVWidgetIds':
        return !!(this.data.item.tvWidgetConfig?.runtimes || []).find(el => !el.startTime || !el.endTime) ? 'packages.navigation.errors.invalidRuntime' : null;
      default:
        return null;
    }
  }
}
